module.exports = __webpack_public_path__ + "img/002-ship.ceded153.svg";